"use client";

import { useEffect, useState } from "react";
import { useRouter, useSearchParams, usePathname } from "next/navigation";
import { Search, X } from "lucide-react";
import { IconButton } from "@/components/icon-button";

export default function QuerySearchInput() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();

  const [value, setValue] = useState(searchParams.get("q") || "");

  const handleSearch = () => {
    const params = new URLSearchParams(searchParams.toString());

    if (value.trim()) {
      params.set("q", value);
    } else {
      params.delete("q");
    }

    router.push(`${pathname}?${params.toString()}`);
  };

  useEffect(() => {
    const currentQ = searchParams.get("q") || "";

    if (value === "" && currentQ !== "") {
      const params = new URLSearchParams(searchParams.toString());
      params.delete("q");
      router.replace(`${pathname}?${params.toString()}`);
    }
  }, [value, searchParams, pathname, router]);

  const handleClear = () => {
    setValue("");
    const params = new URLSearchParams(searchParams.toString());
    params.delete("q");
    router.push(`${pathname}?${params.toString()}`);
  }

  return (
    <div className="w-full flex items-center mx-auto px-4 h-12 py-0.5 border border-section rounded-[40px]">
      <input
        type="text"
        placeholder="جستجو کنید..."
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setValue(e.target.value)
        }
        onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
          if (e.key === "Enter") handleSearch();
        }}
        className="flex-1 outline-none text-sm bg-white py-2 h-full"
      />

      {value && (
        <IconButton
          variant="bare"
          onClick={handleClear}
          ariaLabel="پاک کردن جستجو"
          className="p-1 text-def hover:text-red-500"
        >
          <X size={18} />
        </IconButton>
      )}

      <Search
        size={20}
        className="text-def rotate-90 cursor-pointer"
        onClick={handleSearch}
      />
    </div>
  );
}